import React from 'react';
import { ThemeProvider } from '@emotion/react';
import theme from 'shared/theme';
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';

export function wrapRootElement({ element }) {
  return <ThemeProvider theme={theme}>{element}</ThemeProvider>;
}
